// Helper function to handle docs redirects
const createDocsRedirect = (docsUrl, sliceLength) => {
  return (to, from, next) => {
    const path = to.path.slice(sliceLength)
    const cleanDocsUrl = docsUrl.replace(/\/$/, '')
    const cleanPath = path.startsWith('/') ? path : '/' + path

    // Redirecting with window.location.assign, so we must cancel Vue Router navigation with next(false)
    window.location.assign(cleanDocsUrl + cleanPath)
    next(false)
  }
}

// Configuration object for changelog routing conditions
const CHANGELOG_ROUTES = {
  '/docs/changelog': '/changelog',
  '/v6/docs/changelog': '/changelog',
  '/v5/docs/changelog': '/changelog/v5'
}

// Helper function to handle changelog redirects
const createChangelogRedirect = (to, from, next) => {
  for (const [prefix, redirectPath] of Object.entries(CHANGELOG_ROUTES)) {
    if (to.path.startsWith(prefix)) {
      next(redirectPath)
      return
    }
  }
  createDocsRedirect(FONTAWESOME.DOCS_URL, 5)(to, from, next)
}

let docPaths = []

docPaths.push({
  path: `/v5/docs*`,
  name: `five.docs`,
  beforeEnter: createDocsRedirect(FONTAWESOME.V5_DOCS_URL, 9)
})

docPaths.push({
  path: `/v6/docs*`,
  name: `six.docs`,
  beforeEnter: createDocsRedirect(FONTAWESOME.V6_DOCS_URL, 9)
})

docPaths.push({
  path: `/docs*`,
  name: `latest.docs`,
  beforeEnter: createChangelogRedirect
})

export default docPaths
